export default {
  text: "#000",
  background: "#fff",
  primary: "#e63b19",
  secondary: "#c70d3a",
  sidebar: "#eee",
  linkBackground: "rgba(100, 203, 255, 0.1)",
  linkHoverBackground: "rgba(100, 203, 255, 0.3)",
  inlineCode: "#1a1a1a",
  inlineCodeBackground: "rgba(255,229,100,0.3)",
  borderColor: "rgba(0, 0, 0, 0.15)",
  modes: {
    deep: {
      text: "#fff",
      background: "hsl(230,25%,18%)",
      primary: "hsl(260, 100%, 80%)",
      secondary: "hsl(290, 100%, 80%)",
      sidebar: "hsla(230, 20%, 0%, 20%)",
      borderColor: "rgba(255, 255, 255, 0.15)"
    }
  }
};
